/** ***********
*
* <redirection.interceptor.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpContext,
    HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SKIP_AUTH } from './token-interceptor.service';

@Injectable()
export class RedirectionInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const clone = request.clone();
        return next.handle(clone).pipe(
            switchMap((req) => {
                if (req instanceof HttpResponse && req.body?.messageCode === 'REDIRECT' && req.body?.url) {
                    // throw req.body;
                    return next.handle(
                        new HttpRequest('GET', req.body.url, null, {
                            context: new HttpContext().set(SKIP_AUTH, true),
                        })
                    );
                }
                return of(req);
            })
        );
    }
}
